"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenesysWidget = void 0;
var _config = require("@ori-appshell/config");
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _script = _interopRequireDefault(require("next/script"));
var _react = require("react");
var _getGenesysWidgetSettings = require("./getGenesysWidgetSettings");
var _jsxRuntime = require("react/jsx-runtime");
const GenesysWidget = props => {
  const {
    data,
    environment,
    localizations
  } = props;
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    clientAppsUrl
  } = (0, _configurationManager.useServiceUrls)(['clientApps']);
  const {
    customerId
  } = (0, _auth.useToken)();
  const settings = (0, _react.useMemo)(() => JSON.stringify((0, _getGenesysWidgetSettings.getGenesysWidgetSettings)({
    buttonLabel: localizations.ChatWithUs ?? 'Chat with us',
    currentLanguage: language.split(/-/)[0] ?? 'en',
    data
  })), [language, data, localizations.ChatWithUs]);
  const entryFile = (0, _config.createSpaEntryfileUrl)('genesys-widget', environment, clientAppsUrl);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: "genesys-widget-root",
      "data-app-url": `${clientAppsUrl}/genesys-widget/`,
      "data-customer-id": customerId,
      "data-settings": settings,
      "data-tenant": tenant.toLowerCase()
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_script.default, {
      crossOrigin: "anonymous",
      strategy: "afterInteractive",
      src: entryFile
    })]
  });
};
exports.GenesysWidget = GenesysWidget;
